module.exports = __webpack_public_path__ + "img/gouwuche.b6450a95.svg";